import { withTranslation } from 'react-i18next';
import { Box } from '@mui/material';
import { SwiperSlide } from 'swiper/react';
import { ISelectEventContentProps } from './interfaces';
import SelectEventItem from './SelectEventItem';
import { useStyles } from './styles';
import SwiperWrapper from '@components/SwiperWrapper';
import { sortEventsByLastVisit } from '@helpers/events';
import { SwiperScreenSizes } from '@interfaces';

const SelectEventContent = ({
  events,
  selectedEvent,
  setSelectedEvent,
  t: translate,
}: ISelectEventContentProps) => {
  const classes = useStyles();
  const alwaysOnEvents = sortEventsByLastVisit(
    events.filter((x) => x.isAlwaysOn),
  );
  const scheduledEvents = events.filter((x) => x.isScheduled);

  // Gaps are tighter than the slide count alone would need: the paging arrows
  // take their own room on both sides, and the wide spacing this list used to
  // have left the slides narrower than a preview.
  const breakpointsForEvents = {
    [SwiperScreenSizes.Mobile1]: {
      slidesPerView: 2,
      spaceBetween: 12,
    },
    [SwiperScreenSizes.Mobile2]: {
      slidesPerView: 3,
      spaceBetween: 16,
    },
    [SwiperScreenSizes.Mobile3]: {
      slidesPerView: 3,
      spaceBetween: 20,
    },
    [SwiperScreenSizes.Tablet]: {
      slidesPerView: 3,
      spaceBetween: 24,
    },
    [SwiperScreenSizes.TabletHorizontal]: {
      slidesPerView: 4,
      spaceBetween: 24,
    },
  };

  return (
    <Box sx={classes.root}>
      <SwiperWrapper
        horizontalNavigation
        breakpoints={breakpointsForEvents}
        prevButtonTestId="always-on-experiences-prev-button"
        nextButtonTestId="always-on-experiences-next-button"
      >
        {alwaysOnEvents.map((event) => (
          <SwiperSlide key={event.eventId}>
            <SelectEventItem
              event={event}
              isSelectedEvent={selectedEvent?.eventId === event.eventId}
              setSelectedEvent={setSelectedEvent}
            />
          </SwiperSlide>
        ))}
      </SwiperWrapper>
      {!alwaysOnEvents.length && (
        <Box sx={classes.noEvents}>
          {translate('eventPage.noAlwaysOnEvents')}
        </Box>
      )}
      <Box sx={classes.divider} />
      <Box sx={classes.subTitle}>
        {translate('eventPage.scheduledEvents')}
        {+(scheduledEvents.length || 0) > 0 && (
          <span style={classes.scheduledEventsCounter}>
            ({scheduledEvents.length})
          </span>
        )}
        :
      </Box>
      <SwiperWrapper
        horizontalNavigation
        breakpoints={breakpointsForEvents}
        prevButtonTestId="scheduled-experiences-prev-button"
        nextButtonTestId="scheduled-experiences-next-button"
      >
        {scheduledEvents.map((event) => (
          <SwiperSlide key={event.eventId}>
            <SelectEventItem
              showDateBar
              event={event}
              isSelectedEvent={selectedEvent?.eventId === event.eventId}
              setSelectedEvent={setSelectedEvent}
            />
          </SwiperSlide>
        ))}
      </SwiperWrapper>
      {!scheduledEvents.length && (
        <Box sx={classes.noEvents}>
          {translate('eventPage.noScheduledEvents')}
        </Box>
      )}
    </Box>
  );
};

export default withTranslation()(SelectEventContent);
